export default {"id":"icon-location-pin"}